import { GeneratedAssetType } from './activation-pack';

// =====================================================================
// Print Order
// =====================================================================

export type PrintOrderStatus = 'draft' | 'sending' | 'sent' | 'fulfilled' | 'superseded';

/**
 * One line item in a print order. `assetType` is set when the item was
 * pulled straight from the pack's own generated assets (QR sticker, poster,
 * lookbook) — absent when it was manually attached, e.g. a poster produced
 * outside the app by another agent/designer.
 */
export interface PrintOrderItem {
  id: string;
  label: string;
  url: string;
  quantity: number;
  notes?: string | null;
  assetType?: GeneratedAssetType | null;
}

export interface PrintOrder {
  id: string;
  user_id: string;
  activation_pack_id: string;
  /** Artwork-input revision this editable draft was created against. */
  asset_input_revision: string;
  status: PrintOrderStatus;
  vendor_email: string | null;
  items: PrintOrderItem[];
  notes: string | null;
  sent_at: string | null;
  send_claimed_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface UpdatePrintOrderParams {
  vendor_email?: string | null;
  items?: PrintOrderItem[];
  notes?: string | null;
}

export interface SendPrintOrderParams {
  vendorEmail: string;
  notes?: string;
  expectedUpdatedAt: string;
}

/** Generated asset types eligible for auto-seeding into a fresh print order. */
export const PRINTABLE_ASSET_DEFAULTS: Partial<Record<GeneratedAssetType, { label: string; quantity: number }>> = {
  sticker_pdf: { label: 'QR Code Sticker', quantity: 100 },
  app_poster_pdf: { label: 'App Poster (Print)', quantity: 10 },
  poster_pack_pdf: { label: 'Posters', quantity: 20 },
};
